/* eslint-disable camelcase */
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { RichText, EVEntry } from '../helpers/react'
import { getVariantPath } from '../../utils/get-variant-path'
import { useEntity } from '../helpers/selectors'

const stylePath = (field, variant) =>
  getVariantPath({
    atomicType: 'elements',
    componentId: 'cta',
    variantName: variant,
    field,
  })

const CTA = ({
  button,
  buttonProps,
  className,
  image,
  text,
  variant = image ? 'withImage' : undefined,
  palette,
}) => {
  const imageEntity = useEntity(image)
  const buttonEntity = useEntity(button)

  const getStyles = (field) =>
    stylePath(
      field,
      typeof variant === 'string' && variant.toLowerCase().includes('image') && !image
        ? undefined
        : variant === 'default' && image
        ? 'withImage'
        : variant,
    )

  return (
    <div sx={{ variant: !palette && getStyles('background') }} className={className}>
      <div sx={{ variant: getStyles('wrapper') }}>
        <div sx={{ variant: getStyles('textWrapper') }}>
          <If condition={text}>
            <RichText style={{ variant: getStyles('text') }} content={text.content} />
          </If>

          <EVEntry sx={{ variant: getStyles('button') }} {...buttonEntity} {...buttonProps} />
        </div>

        <If condition={image}>
          <div sx={{ variant: getStyles('imageWrapper') }}>
            <EVEntry
              {...imageEntity}
              sx={{ variant: getStyles('image') }}
              aspectRatioProps={{
                sx: { variant: getStyles('aspectRatioWrapper') },
              }}
            />
          </div>
        </If>
      </div>
    </div>
  )
}

export default CTA
